export const Portals = {
  default: 'portal',
  dialog: 'dialog-portal',
  navigation: 'navigation-portal',
  snackbar: 'snackbar-portal',
}
